export default __webpack_public_path__ + "static/media/web_banner.35fd6ab5.png";